exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-title[data-v-7001cbab] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 52px;\n}\n.grid-title h4[data-v-7001cbab] {\n  margin-top: 0;\n  width: 100%;\n}\nthead[data-v-7001cbab] {\n  position: relative;\n  z-index: 1;\n}\n.show-status[data-v-7001cbab] {\n  position: relative;\n  overflow: hidden;\n}\n.show-status .status-label[data-v-7001cbab] {\n  position: absolute;\n  bottom: 3px;\n  right: -14px;\n  width: 45px;\n  transform: rotate(315deg);\n  font-size: 8px;\n  background-color: red;\n  color: white;\n  text-align: center;\n}", ""]);

// exports
